var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.AccountsPayable"),
                name: "AccountsPayable",
                lazy: "",
              },
            },
            [
              _vm.activeName === "AccountsPayable"
                ? _c(
                    "div",
                    [_c("AccountsPayable", { ref: "AccountsPayable" })],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.HutDispatchAccountsPayable"),
                name: "Hut",
                lazy: "",
              },
            },
            [
              _vm.activeName === "Hut"
                ? _c("div", [_c("Hut", { ref: "CustomerAccount" })], 1)
                : _vm._e(),
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.DispatchAccountsPayable"),
                name: "AJD",
                lazy: "",
              },
            },
            [
              _vm.activeName === "AJD"
                ? _c("div", [_c("AJD", { ref: "AJD" })], 1)
                : _vm._e(),
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.DspDispatchAccountsPayable"),
                name: "DSP",
                lazy: "",
              },
            },
            [
              _vm.activeName === "DSP"
                ? _c("div", [_c("DSP", { ref: "DSP" })], 1)
                : _vm._e(),
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.AccountsReceivablePayable"),
                name: "AccountsReceivablePayable",
                lazy: "",
              },
            },
            [
              _vm.activeName === "AccountsReceivablePayable"
                ? _c(
                    "div",
                    [
                      _c("AccountsReceivablePayable", {
                        ref: "AccountsReceivablePayable",
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("RouterObj.CostsPayableAccount"),
                name: "CostsPayableAccount",
                lazy: "",
              },
            },
            [
              _vm.activeName === "CostsPayableAccount"
                ? _c(
                    "div",
                    [_c("CostsPayableAccount", { ref: "CostsPayableAccount" })],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }